import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import { useContext, useMemo } from 'react'

import PostMeta from '@/components/posts/PostMeta'
import UserPostSingle from '@/components/users/screens/UserPostSingle'
import HNContext from '@/context/HNContext'
import { withSessionInServer } from '@/lib/helpers/nextHelpers'
import { userSidePostSinglePath } from '@/lib/helpers/pathHelpers'
import { getPost } from '@/models/Post'
import type { IPost } from '@/types/post'

interface IPropTypes {
  post?: IPost
}
const PostSinglePage = (props: IPropTypes) => {
  const { post } = props
  const router = useRouter()
  const { organization } = useContext(HNContext)

  const { postSlug, ...rest } = router.query as {
    postSlug: string
    [key: string]: string
  }

  const shouldAddCanonical = useMemo(() => {
    if (!organization) return false
    if (!postSlug) return false
    if (Object.keys(rest).length) return true
    return false
  }, [router.query])

  return (
    <>
      <NextSeo
        canonical={
          shouldAddCanonical
            ? userSidePostSinglePath(postSlug, organization?.home_page)
            : undefined
        }
      />
      <div className='bg-gray2 pt-5'>
        <UserPostSingle post={post} />
        <PostMeta post={post} />
      </div>
    </>
  )
}

export const getServerSideProps = withSessionInServer(
  async (ctx: any, headers) => {
    const isDataReq = ctx.req?.url?.startsWith('/_next/data')
    if (isDataReq) return { props: {} }

    try {
      const { params } = ctx
      const post = await getPost(params.postSlug, headers)
      return {
        props: {
          post,
        },
      }
    } catch (err) {
      return {
        props: {},
      }
    }
  }
)

export default PostSinglePage
